// extracted by mini-css-extract-plugin
export default {"Candidates":"styles_Candidates__GYI+q"};